import { render, staticRenderFns } from "./address-directory.vue?vue&type=template&id=f4ac1182"
import script from "./address-directory.vue?vue&type=script&lang=js"
export * from "./address-directory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports